import { IAddress } from "@interface/customerDetails/IAddress";

export const capitalizeWord = (word: string) => word.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const countyFormatter = (county: string) => (county ? capitalizeWord(county.replace("_", ". ")) : "");

export const addressFormatter = (address: IAddress, displayEircode?: boolean) => {
    const addressFields = [
        address.addressLine1,
        address.addressLine2,
        address.addressLine3,
        address.town,
        countyFormatter(address.county),
    ]
        .filter(Boolean)
        .map(capitalizeWord);

    if (displayEircode && address.eircode) {
        addressFields.push(address.eircode);
    }

    return addressFields.join(", ");
};
